import { auth } from "@/api/session";

export default {
  getToken() {
    return auth.post(`/tokens/`);
  },
  getRefreshToken(token) {
    return auth.post(`/tokens/refresh/`, { refresh: token });
  },
};
